import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LandingPageService } from 'src/app/services/landingpage.service';
import { AvailbilityComponent } from '../availbility.component';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'app-modifySearch',
    templateUrl: './modifySearch.component.html',
    styleUrls: ['./modifySearch.component.css']
})
export class ModifySearchComponent implements OnInit {

    locations: any[] = [];
    cruiseLines: any[] = [];
    place: string = "";
    cruiseLine: any = '';
    cruiseAvailability: {};
    exclusiveDeals: any[] = [];
    sailMonths: any[] = [];
    sailDate: any = "";
    duration: any = "";
    // rooms: any[] = []
    activeRoom: any = {
        type:  "Interior",
        adults: 2,
        childs: 0,
        infants: 0
    };
    total: any = {
        adults: 0,
        childs: 0,
        infants: 0
    };
    searchString: string = "";
    cruiseCode: string = "";

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private landingPageService: LandingPageService, private toastr: ToastrService,
        private route: ActivatedRoute, private router: Router, private ac: AvailbilityComponent) {
        route.params.subscribe(params => {
            this.searchString = params["searchstring"];
            let parameters = this.searchString.split("---");
            if (parameters.length > 2)
            {
            this.place = parameters[0];
            this.sailDate = parameters[1];
            this.duration = parameters[2];
            this.cruiseLine = parameters[3];
            this.cruiseCode = parameters[4];
            }
            else
            {
                this.cruiseLine=parameters[0];
            }
        })
    }

    ngOnInit() {
        this.getSailMonths();
        if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("room", JSON.stringify(this.activeRoom));
    }

    toggleMenu() {
        document.getElementById("PaxRoomDropDown").classList.toggle('show');
    }
    makeItBlank(event) {
        jQuery(event.target).val("");
    }
    getLocations(event) {
        this.place = event.target.value;
        if (this.place.length > 2)
            this.landingPageService.getLocations(this.place).subscribe(
                data => {
                    let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp.locations) {
                        this.locations = resp.locations;
                    }
                },
                error => {
                    console.log(error);
                }
            )
    }

    setLocation(loc) {
        this.place = loc;
        this.locations = [];
    }

    getSailMonths() {
        this.landingPageService.getSailMonths().subscribe(
            data => {
                let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                if (resp.status == 'success') {
                    this.sailMonths = resp.months;
                }
            },
            error => {
                console.log(error);
            }
        )
    }

    // addRooms() {
    //     if(this.rooms.length<4){
    //         let room = this.activeRoom;
    //         this.rooms.push(room);
    //         this.activeRoom = {
    //             type:"",
    //             adults:0,
    //             childs:0,
    //             infants:0
    //         };
    //     } else {
    //         this.toastr.warning("Only 4 rooms can be added max...!");
    //     }
    // }

    add(type) {
        if (type == 'adult') {
            this.activeRoom.adults = Number(this.activeRoom.adults) + 1;
        }
        if (type == 'child') {
            this.activeRoom.childs = Number(this.activeRoom.childs) + 1
        }
        if (type == 'infant') {
            this.activeRoom.infants = Number(this.activeRoom.infants) + 1;
        }
    }

    reduce(type) {
        if (type == 'adult') {
            if (this.activeRoom.adults > 0) {
                this.activeRoom.adults = this.activeRoom.adults - 1;
            }
        }
        if (type == 'child') {
            if (this.activeRoom.childs > 0) {
                this.activeRoom.childs = this.activeRoom.childs - 1;
            }
        }
        if (type == 'infant') {
            if (this.activeRoom.infants > 0) {
                this.activeRoom.infants = this.activeRoom.infants - 1;
            }
        }
    }

    // editRoom(index,room) {
    //     this.rooms.splice(index,1);
    //     this.activeRoom = room;
    // }

    // deleteRoom(index) {
    //     this.rooms.splice(index,1);
    // }

    saveRooms() {
        // if(this.rooms.length<4) {
        //     this.rooms.push(this.activeRoom);
        // }
        // this.toggleMenu();
        // for(let room of this.rooms){
        //     this.total["adults"] = Number(this.total["adults"]) + Number(room.adults);
        //     this.total["childs"] = Number(this.total["childs"]) + Number(room.childs);
        //     this.total["infants"] = Number(this.total["infants"]) + Number(room.infants);
        // }
        let total = Number(this.activeRoom.adults) + Number(this.activeRoom.childs) +
            Number(this.activeRoom.infants);
        if (this.activeRoom.type == "1" && total > 4) {
            this.toastr.error("Total Members in Mini Suite should not exceed 4");
            return false;
        } else if (this.activeRoom.type == "2" && total > 3) {
            this.toastr.error("Total Members in Balcony should not exceed 3");
            return false;
        } else if (this.activeRoom.type == "3" && total > 4) {
            this.toastr.error("Total Members in Ocean View should not exceed 4");
            return false;
        } else if (this.activeRoom.type == "4" && total > 4) {
            this.toastr.error("Total Members in Interior should not exceed 4");
            return false;
        }
        this.toggleMenu();
    }

    filterData() {
        var qstring = "";
        if (this.sailDate) {
            qstring = this.place + "---" + this.sailDate + "---" ;
        } else {
            qstring = this.place + "---" + "" + "---" ;
        }
        if (this.duration != '') {
            qstring = qstring + this.duration + "---";
        } else {
            qstring = qstring + "---";
        }
        if (this.cruiseLine != '') {
            qstring = qstring + this.cruiseLine + "---";
        } else {
            qstring = qstring + "---";
        }

        // This last index for Cruise Code
        qstring = qstring + "---";

        $('#closeModal').click();
        $('.modal-backdrop').toggleClass('show');
        $('.modal-backdrop').remove();
        if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("room", JSON.stringify(this.activeRoom));
        this.router.navigate(["availbility/" + qstring]);
        setTimeout(() => {
            this.ac.modifySearch();
        }, 500);
    }
}
